(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@aws-amplify/core"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_auth", ["@aws-amplify/core"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_auth"] = factory(require("@aws-amplify/core"));
	else
		root["aws_amplify_auth"] = factory(root["@aws-amplify/core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__3__) {
return 